import { object, string } from 'yup';

import client from '$app-web/core/client';

const responseSchema = object()
    .shape({
        name: string().required(),
        orgName: string().required(),
        appBg: string().required(),
        desc: string().required(),
    })
    .camelCase();

const requestSchema = object().shape({
    study_id: string().required(),
});

const useReadStudyBasicInfoEndpoint = client.registerEndpoint('GET api/read-study-basic-info', '/study/info/basic/', {
    responseSchema,
    requestSchema,
});

export default useReadStudyBasicInfoEndpoint;
